import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t-4 border-white" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-45">
          <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-46">
            <a href="#" className="font-bangers text-4xl text-[#FFD700] tracking-wider block mb-2" data-id="element-47">
              COMICUT
            </a>
            <p className="font-inter text-gray-400 text-sm font-medium" data-id="element-48">
              © 2026 Comicut App. PIXO Inc. All rights reserved.
            </p>
          </div>

          <div className="flex space-x-6 font-bangers text-xl tracking-wide" data-id="element-49">
            <a href="#" className="hover:text-[#FFD700] transition-colors" data-id="element-50">
              Twitter
            </a>
            <a href="#" className="hover:text-[#FFD700] transition-colors" data-id="element-51">
              Instagram
            </a>
            <a href="#" className="hover:text-[#FFD700] transition-colors" data-id="element-52">
              TikTok
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-8 font-inter text-sm text-gray-500 font-medium" data-id="element-53">
          <a href="https://go.pixo.co/comicut-privacy" className="hover:text-white transition-colors" data-id="element-54">
            Privacy Policy
          </a>
          <a href="https://go.pixo.co/comicut-terms" className="hover:text-white transition-colors" data-id="element-55">
            Terms of Service
          </a>
          <a href="mailto:support@pixo.co" className="hover:text-white transition-colors" data-id="element-56">
            Contact Support
          </a>
        </div>
      </div>
    </footer>;
}